export const dynamicComponentConstants = {
    MODULES: [
        {
            'type': 'AddressUpdateComponent',
            'selector': 'app-address-update'
        },
        {
            'type': 'PensionCalculationDetailsComponent',
            'selector': 'al-pension-calculation-details'
        },
        {
            'type': 'RetirementProjectionComponent',
            'selector': 'al-retirement-projection-lazy'
        },
        {
            'type': 'DcAccountSummaryWidgetComponent',
            'selector': 'dcaccountsummary-widget'
        },
        {
            'type': 'DcLoanComponent',
            'selector': 'al-dc-loan'
        },
        {
            'type': 'EmailUpdateComponent',
            'selector': 'app-email-update'
        },
        {
            'type': 'WorkdayStatusWidgetComponent',
            'selector': 'al-workday-status'
        },
        {
            'type': 'AlTipsAndNewsLinkComponent',
            'selector': 'al-tips-and-news-link-widget'
        },
        {
            'type': 'TileComponent',
            'selector': 'al-tiles'
        },
        {
            'type': 'AlThirdPartyLegalDisclaimerComponent',
            'selector': 'al-third-party-legal-disclaimer-widget'
        },
        {
            'type': 'FavoriteTileComponent',
            'selector': 'al-fav-tiles'
        },
        {
            'type': 'KBLandingComponent',
            'selector': ''
        },
        {
            'type': 'AuthenticationComponent',
            'selector': 'al-authentication-widget'
        },
        {
            'type': 'PensionFormulaComponent',
            'selector': 'al-pension-formula'
        },
        {
            'type': 'PersonalInformationComponent',
            'selector': 'al-personal-information'
        },
        {
            'type': 'PhoneUpdateComponent',
            'selector': 'app-phone-update'
        }
    ]
};
